// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as $$Promise from "common/src/Promise.bs.js";
import * as ShortUrl from "../bindings/ShortUrl.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as SnackbarService from "common/src/SnackbarService.bs.js";
import CopyToClipboard from "copy-to-clipboard";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Share from "@mui/icons-material/Share";

function displaySnackbar(param) {
  var cb = SnackbarService.sub.contents;
  if (cb !== undefined) {
    return Curry._1(cb, "Link copied to clipboard");
  }
  
}

function copyShortlink(url) {
  CopyToClipboard(url);
  return $$Promise.consume2($$Promise.map(ShortUrl.make(url), (function (key) {
                    return "https://tactics.tools/s/" + key;
                  })), (function (shortUrl) {
                CopyToClipboard(shortUrl);
                return displaySnackbar(undefined);
              }), (function (param) {
                return displaySnackbar(undefined);
              }));
}

function Share$Button(Props) {
  var forceFullOpt = Props.forceFull;
  var url = Props.url;
  var sizeOpt = Props.size;
  var classNameOpt = Props.className;
  var forceFull = forceFullOpt !== undefined ? forceFullOpt : false;
  var size = sizeOpt !== undefined ? sizeOpt : "small";
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var t = Translation.useT(/* Common */0);
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: forceFull ? "" : "hidden md:block"
                }, React.createElement(Button, {
                      classes: {
                        root: className
                      },
                      startIcon: React.createElement(Share, {}),
                      onClick: (function (param) {
                          return copyShortlink(url);
                        }),
                      variant: "contained",
                      color: "secondary",
                      size: size,
                      children: t("Share")
                    })), React.createElement("div", {
                  className: forceFull ? "hidden" : "md:hidden"
                }, React.createElement(IconButton, {
                      color: "primary",
                      onClick: (function (param) {
                          return copyShortlink(url);
                        }),
                      size: "small",
                      children: React.createElement(Share, {
                            fontSize: "small"
                          })
                    })));
}

var Button$1 = {
  make: Share$Button
};

export {
  displaySnackbar ,
  copyShortlink ,
  Button$1 as Button,
  
}
/* react Not a pure module */
